/*
  Composez votre pack - Ariana.

  Affiche le calcul du pack (5 % des 2 produits, 10 % des 3 par defaut) et ajoute tous
  les produits au panier en une requete. Le prix reellement facture vient des remises
  automatiques Shopify « Pack » : ce script ne modifie aucun prix.
*/
(function () {
  if (window.AxPackBuilder) return;

  function formatMoney(cents, format) {
    var value = (cents || 0) / 100;
    function sep(num, decimals, thousands, decimal) {
      var parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts.join(decimal) : parts[0];
    }
    return (format || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      switch (token) {
        case 'amount_no_decimals': return sep(value, 0, ',', '.');
        case 'amount_with_comma_separator': return sep(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return sep(value, 0, '.', ',');
        case 'amount_with_space_separator': return sep(value, 2, ' ', ',');
        default: return sep(value, 2, ',', '.');
      }
    });
  }

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var NBSP = ' ';

  function PackBuilder(root) {
    var self = this;
    this.root = root;
    this.min = parseInt(root.dataset.min, 10) || 2;
    this.d2 = parseFloat(root.dataset.d2) || 0;
    this.d3 = parseFloat(root.dataset.d3) || 0;
    this.money = root.dataset.moneyFormat || '{{amount}} dh';
    this.addedLabel = root.dataset.addedLabel || 'Ajouté';
    this.lines = [];
    this.variants = {};
    this.cards = [];
    this.busy = false;

    Array.prototype.forEach.call(root.querySelectorAll('[data-pb-card]'), function (el) {
      var node = el.querySelector('[data-pb-json]');
      if (!node) return;
      var data;
      try { data = JSON.parse(node.textContent); } catch (e) { return; }
      if (!data.variants || !data.variants.length) return;
      var first = data.variants.find(function (v) { return v.a; }) || data.variants[0];
      var card = { el: el, data: data, sel: String(first.id) };
      data.variants.forEach(function (v) { self.variants[String(v.id)] = { card: card, v: v }; });
      self.cards.push(card);
    });

    root.addEventListener('click', this.onClick.bind(this));
    this.render();
  }

  PackBuilder.prototype.count = function () {
    return this.lines.reduce(function (a, l) { return a + l.qty; }, 0);
  };

  /* Doit rester identique aux remises automatiques Shopify. */
  PackBuilder.prototype.pct = function (n) {
    if (n >= 3) return this.d3 || this.d2;
    if (n >= 2) return this.d2;
    return 0;
  };

  PackBuilder.prototype.find = function (vid) {
    return this.lines.find(function (l) { return l.vid === vid; });
  };

  PackBuilder.prototype.add = function (vid) {
    if (!this.variants[vid]) return;
    var line = this.find(vid);
    if (line) line.qty += 1;
    else this.lines.push({ vid: vid, qty: 1 });
    this.render();
  };

  PackBuilder.prototype.dec = function (vid) {
    var line = this.find(vid);
    if (!line) return;
    line.qty -= 1;
    if (line.qty <= 0) this.lines = this.lines.filter(function (l) { return l !== line; });
    this.render();
  };

  PackBuilder.prototype.cardFor = function (el) {
    var host = el.closest('[data-pb-card]');
    return this.cards.find(function (c) { return c.el === host; });
  };

  PackBuilder.prototype.onClick = function (e) {
    var t = e.target;
    var el;
    if ((el = t.closest('[data-pb-filter]'))) return this.filter(el);
    if ((el = t.closest('[data-pb-variant]'))) return this.pickVariant(el);
    if ((el = t.closest('[data-pb-add]'))) {
      var card = this.cardFor(el);
      if (card) { this.add(card.sel); this.flash(el); }
      return;
    }
    if ((el = t.closest('[data-pb-inc]'))) return this.add(el.getAttribute('data-pb-inc'));
    if ((el = t.closest('[data-pb-dec]'))) return this.dec(el.getAttribute('data-pb-dec'));
    if ((el = t.closest('[data-pb-toggle]'))) {
      var open = !this.root.classList.contains('is-open');
      this.root.classList.toggle('is-open', open);
      el.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if ((el = t.closest('[data-pb-cta]'))) return this.submit(el);
  };

  PackBuilder.prototype.filter = function (btn) {
    var key = btn.getAttribute('data-pb-filter');
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-pb-filter]'), function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    this.cards.forEach(function (c) {
      var cats = (c.el.getAttribute('data-cats') || '').trim().split(/\s+/);
      c.el.hidden = !(key === 'all' || cats.indexOf(key) > -1);
    });
  };

  PackBuilder.prototype.pickVariant = function (chip) {
    if (chip.disabled) return;
    var card = this.cardFor(chip);
    if (!card) return;
    card.sel = chip.getAttribute('data-pb-variant');
    Array.prototype.forEach.call(card.el.querySelectorAll('[data-pb-variant]'), function (c) {
      var on = c === chip;
      c.classList.toggle('is-on', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var entry = this.variants[card.sel];
    var price = card.el.querySelector('[data-pb-price]');
    if (entry && price) price.textContent = formatMoney(entry.v.p, this.money);
  };

  PackBuilder.prototype.flash = function (btn) {
    if (!btn.dataset.label) btn.dataset.label = btn.textContent;
    btn.classList.add('is-added');
    btn.textContent = this.addedLabel;
    clearTimeout(btn._pbTimer);
    btn._pbTimer = setTimeout(function () {
      btn.classList.remove('is-added');
      btn.textContent = btn.dataset.label;
    }, 1100);
  };

  PackBuilder.prototype.all = function (sel) {
    return this.root.querySelectorAll(sel);
  };

  PackBuilder.prototype.render = function () {
    var self = this;
    var n = this.count();
    var d = this.pct(n);
    var sub = this.lines.reduce(function (a, l) {
      var e = self.variants[l.vid];
      return a + (e ? e.v.p * l.qty : 0);
    }, 0);
    var total = Math.round(sub * (1 - d / 100));
    var saving = sub - total;
    var fmt = function (c) { return formatMoney(c, self.money); };

    Array.prototype.forEach.call(this.all('[data-pb-count]'), function (el) { el.textContent = n; });

    var empty = this.root.querySelector('[data-pb-empty]');
    if (empty) empty.hidden = n > 0;

    var list = this.root.querySelector('[data-pb-lines]');
    if (list) {
      list.innerHTML = this.lines.map(function (l) {
        var e = self.variants[l.vid];
        if (!e) return '';
        var variantTitle = e.v.t && e.v.t !== 'Default Title' ? e.v.t : '';
        return '<li class="ax-pb-line">' +
          '<img class="ax-pb-line__img" src="' + esc(e.card.data.img) + '" alt="" width="48" height="48" decoding="async">' +
          '<div><p class="ax-pb-line__title">' + esc(e.card.data.title) + '</p>' +
          (variantTitle ? '<p class="ax-pb-line__var">' + esc(variantTitle) + '</p>' : '') +
          '<p class="ax-pb-line__price">' + esc(fmt(e.v.p * l.qty)) + '</p></div>' +
          '<div class="ax-pb-line__qty">' +
          '<button type="button" data-pb-dec="' + esc(l.vid) + '" aria-label="Retirer un exemplaire">−</button>' +
          '<span>' + l.qty + '</span>' +
          '<button type="button" data-pb-inc="' + esc(l.vid) + '" aria-label="Ajouter un exemplaire">+</button>' +
          '</div></li>';
      }).join('');
    }

    /* Pastille « Dans le pack » sur chaque carte. */
    var perProduct = {};
    this.lines.forEach(function (l) {
      var e = self.variants[l.vid];
      if (e) perProduct[e.card.data.id] = (perProduct[e.card.data.id] || 0) + l.qty;
    });
    this.cards.forEach(function (c) {
      var qty = perProduct[c.data.id] || 0;
      c.el.classList.toggle('is-in', qty > 0);
      var badge = c.el.querySelector('[data-pb-in]');
      if (badge) {
        badge.hidden = qty === 0;
        badge.textContent = qty > 0 ? 'Dans le pack ×' + qty : '';
      }
    });

    Array.prototype.forEach.call(this.all('[data-pb-tier]'), function (chip) {
      var tier = parseInt(chip.getAttribute('data-pb-tier'), 10);
      chip.classList.toggle('is-on', tier === 3 ? n >= 3 : n === 2);
    });
    Array.prototype.forEach.call(this.all('[data-pb-mark]'), function (mark) {
      mark.classList.toggle('is-reached', n >= parseInt(mark.getAttribute('data-pb-mark'), 10));
    });

    var bar = this.root.querySelector('[data-pb-bar]');
    if (bar) bar.style.width = Math.min(n / 3, 1) * 100 + '%';

    var msg;
    if (n === 0) msg = 'Dès 2 produits : −' + this.d2 + NBSP + '% · dès 3 produits : −' + this.d3 + NBSP + '%';
    else if (n < 2) msg = 'Encore 1 produit pour profiter de −' + this.d2 + NBSP + '%';
    else if (n < 3) msg = 'Encore 1 produit pour passer à −' + this.d3 + NBSP + '%';
    else msg = 'Remise maximale débloquée : −' + (this.d3 || this.d2) + NBSP + '%';
    var msgNode = this.root.querySelector('[data-pb-msg]');
    if (msgNode) msgNode.textContent = msg;

    var set = function (sel, text) {
      var node = self.root.querySelector(sel);
      if (node) node.textContent = text;
    };
    set('[data-pb-sub]', fmt(sub));
    set('[data-pb-total]', fmt(total));
    set('[data-pb-disc]', '−' + fmt(saving));
    set('[data-pb-disc-label]', 'Remise pack (−' + d + NBSP + '%)');
    var discRow = this.root.querySelector('[data-pb-disc-row]');
    if (discRow) discRow.hidden = saving <= 0;

    if (!this.busy) {
      var ready = n >= this.min;
      var missing = this.min - n;
      Array.prototype.forEach.call(this.all('[data-pb-cta]'), function (cta) {
        cta.disabled = !ready;
        if (ready) cta.textContent = 'Ajouter le pack · ' + fmt(total);
        else if (n === 0) cta.textContent = 'Ajoutez au moins ' + self.min + ' produits';
        else cta.textContent = 'Encore ' + missing + ' produit' + (missing > 1 ? 's' : '');
      });
    }
  };

  PackBuilder.prototype.showError = function (text) {
    var node = this.root.querySelector('[data-pb-error]');
    if (!node) return;
    node.textContent = text || '';
    node.hidden = !text;
  };

  PackBuilder.prototype.submit = function () {
    var self = this;
    if (this.busy || this.count() < this.min) return;
    this.busy = true;
    this.showError('');
    Array.prototype.forEach.call(this.all('[data-pb-cta]'), function (cta) {
      cta.disabled = true;
      cta.textContent = 'Ajout en cours…';
    });

    var drawer = document.querySelector('cart-drawer');
    var body = {
      items: this.lines.map(function (l) { return { id: Number(l.vid), quantity: l.qty }; })
    };
    var useDrawer = drawer && typeof drawer.getSectionsToRender === 'function' && typeof drawer.renderContents === 'function';
    if (useDrawer) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.section; });
      body.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json().then(function (json) { return { ok: res.ok, json: json }; });
      })
      .then(function (result) {
        if (!result.ok || result.json.status) {
          throw new Error(result.json.description || result.json.message || 'Impossible d’ajouter le pack.');
        }
        self.lines = [];
        self.busy = false;
        self.root.classList.remove('is-open');
        self.render();

        if (useDrawer && result.json.sections) {
          /* Comme product-form.js : sans ce retrait, open() croit le tiroir vide, cherche
             .drawer__inner-empty (remplace par renderContents) et trapFocus plante sur null. */
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          try {
            drawer.renderContents(result.json);
          } catch (err) {
            window.location.href = '/cart';
            return;
          }
          setTimeout(function () {
            if (!drawer.classList.contains('active') && typeof drawer.open === 'function') drawer.open();
          }, 180);
        } else {
          window.location.href = '/cart';
          return;
        }

        /* Pas de publish(cartUpdate) : renderContents a deja rendu le tiroir et la pastille
           du panier, et certains abonnes du theme attendent une charge utile de
           product-form (ils levaient « null.querySelectorAll »). */
      })
      .catch(function (err) {
        self.busy = false;
        self.render();
        self.showError(err && err.message ? err.message : 'Impossible d’ajouter le pack.');
      });
  };

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ax-pb]'), function (el) {
      if (el._axPb) return;
      el._axPb = new PackBuilder(el);
    });
  }

  window.AxPackBuilder = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
